import { render, staticRenderFns } from "./SpecialDeleteButton.vue?vue&type=template&id=48c6f46a&"
import script from "./SpecialDeleteButton.vue?vue&type=script&lang=js&"
export * from "./SpecialDeleteButton.vue?vue&type=script&lang=js&"
import style0 from "./SpecialDeleteButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCol,VHover,VIcon,VProgressCircular})
